import React from "react";
import DataTable from "react-data-table-component";
import moment from "moment";
import CurrencyInput from "react-currency-input-field";
import Moment from "moment";
import Select from "react-select";
// react-bootstrap components
import {
  Badge,
  Button,
  Card,
  Form,
  InputGroup,
  Navbar,
  Nav,
  TabContent,
  TabPane,
  Container,
  Collapse,
  Row,
  Col,
  Tab,
  Modal,
  ModalBody,
  Table,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { number } from "prop-types";
import { getAllPencairan } from "stores/Pengajuan/function";
import { InfinitySpin, Oval } from "react-loader-spinner";
import ReactPaginate from "react-paginate";
import "./Pagination.css";
import { mirage, quantum } from "ldrs";
import Swal from "sweetalert2";
import { showUrlDokumen } from "stores/Pengajuan/function";
import { showUrlDokumenKunjungan } from "stores";
import GoogleMapReact from "google-map-react";

function Pencairan() {
  quantum.register();
  const dataPencairan = useSelector((state) => state.pengajuanReducer);
  const [modalDetails, setModalDetails] = React.useState(false);
  const [detailPencairan, setDetailPencairan] = React.useState([]);
  const [modalDokumen, setModalDokumen] = React.useState(false);
  const [listDokumenAgunan, setListDokumenAgunan] = React.useState([]);
  const [loadingDokumen, setLoadingDokumen] = React.useState(false);
  const dispatch = useDispatch();
  const [listPencairan, setListPencairan] = React.useState([]);
  const [listTujuanPenggunaan, setListTujuanPenggunaan] = React.useState([]);
  const [pilihTujuanPenggunaan, setPilihTujuanPenggunaan] = React.useState("");
  const [filterTujuanPenggunaan, setFilterTujuanPenggunaa] =
    React.useState(null);
  const [searchText, setSearchText] = React.useState("");
  Moment.locale("id");
  const tanggalAkad = Moment(detailPencairan.tglAkad).format("DD MMMM YYYY");
  const tanggalAgenda = Moment(detailPencairan.tglAgenda).format(
    "DD MMMM YYYY",
  );
  const [pending, setPending] = React.useState(false);
  const [totalPerHalaman, setTotalPerHalaman] = React.useState(10);
  const [page, setPage] = React.useState(0);
  const [filterStatus, setFilterStatus] = React.useState(null);
  const [buktiKunjungan, setBuktiKunjungan] = React.useState("");
  const [latitude, setLatitude] = React.useState(null);
  const [longitude, setLongitude] = React.useState(null);
  const handlePageSizeChange = (selectedOption) => {
    setTotalPerHalaman(selectedOption.value);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleFilterChange();
    }
  };

  const handleFilterChange = () => {
    setPending(true);
    setPage(0);
    getAllPencairan(dispatch, {
      status: "Disetujui",
      page: 1,
      limit: totalPerHalaman,
      cari: searchText,
      tujuanPenggunaan: pilihTujuanPenggunaan,
    })
      .then((response) => {
        setPending(false);
      })
      .catch((error) => {
        setPending(false);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Terjadi kesalahan saat memuat data.",
        });
      });
  };

  const handleSearch = (e) => {
    setSearchText(e.target.value);
  };

  const handleClearSearch = () => {
    setSearchText("");
  };

  const handleBukaUkuranPenuh = async (urlAsli, fallbackUrl) => {
    // Buka tab kosong dulu secara sinkron agar tidak diblokir oleh popup blocker browser
    const newWindow = window.open("", "_blank");
    if (newWindow) {
      newWindow.document.write("<html><head><title>Memuat Dokumen...</title></head><body style='display:flex;justify-content:center;align-items:center;height:100vh;font-family:sans-serif;color:#64748b;background-color:#f8fafc;'><h2>Sedang menyiapkan dokumen...</h2></body></html>");
    }

    try {
      const res = await showUrlDokumen(dispatch, { urlImage: urlAsli });
      if (res && res.data && res.data.url) {
        if (newWindow) newWindow.location.href = res.data.url;
        else window.open(res.data.url, "_blank");
      } else {
        if (newWindow) newWindow.location.href = fallbackUrl;
        else window.open(fallbackUrl, "_blank");
      }
    } catch (err) {
      if (newWindow) newWindow.location.href = fallbackUrl;
      else window.open(fallbackUrl, "_blank");
    }
  };

  const options = [
    { value: 10, label: "10" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
  ];

  const DetailRow = ({
    label,
    value,
    col = 6,
    isPrimary = false,
    color = "black",
  }) => (
    <Col md={col} className="mb-3">
      <label
        className="text-muted small fw-bold text-uppercase d-block mb-1"
        style={{ fontSize: "10px", letterSpacing: "0.5px" }}
      >
        {label}
      </label>
      <div
        style={{
          fontSize: isPrimary ? "16px" : "14px",
          fontWeight: isPrimary ? "800" : "600",
          color: color,
          padding: "5px 0",
        }}
      >
        {value || "-"}
      </div>
    </Col>
  );

  React.useEffect(() => {
    if (dataPencairan.listPencairan.data) {
      let tmp = dataPencairan.listPencairan.data.map((val) => {
        // console.log(val, "DATA PENCARIAN");
        // console.log(val.stepEnam, "DATA DOKUMEN STEP ENAM");
        return {
          ...val,
          namaCabangPencairan: !val.lokasiPencairan
            ? "-"
            : val.lokasiPencairan.namaCabang,
          nominalPermohonan: !val.nominalPermohonan
            ? "-"
            : val.stepEmpat.nominalPermohonan,
          action: (<>
            <div className="d-flex justify-content-center align-items-center">
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip id={`tooltip-details-${val._id}`}>
                    Detail Pencairan
                  </Tooltip>
                }
              >
                <Button
                  className="btn-icon d-flex align-items-center justify-content-center shadow-sm"
                  style={{
                    width: "35px",
                    height: "35px",
                    borderRadius: "10px",
                    backgroundColor: "#E0F2FE",
                    border: "1px solid #BAE6FD",
                    color: "#0369A1",
                    transition: "all 0.2s ease",
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.backgroundColor = "#0369A1";
                    e.currentTarget.style.color = "#ffffff";
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.backgroundColor = "#E0F2FE";
                    e.currentTarget.style.color = "#0369A1";
                  }}
                  onClick={async () => {
                    // console.log(val, "DATA DETAIL PENCARIAN");
                    setModalDetails(true);
                    setDetailPencairan(val);

                    // ===== SET KOORDINAT AWAL MAP PADA MODAL =====
                    if (
                      val.listSemuaKunjungan &&
                      val.listSemuaKunjungan.length > 0
                    ) {
                      const kunjunganPertama = val.listSemuaKunjungan[0];
                      setLatitude(
                        kunjunganPertama.lat
                          ? parseFloat(kunjunganPertama.lat)
                          : -0.4948,
                      );
                      setLongitude(
                        kunjunganPertama.long
                          ? parseFloat(kunjunganPertama.long)
                          : 117.1355,
                      );
                    } else {
                      setLatitude(null);
                      setLongitude(null);
                    }

                    // ===== PROSES AMBIL SEMUA FOTO KUNJUNGAN =====
                    if (
                      val.listSemuaKunjungan &&
                      val.listSemuaKunjungan.length > 0
                    ) {
                      let tempUrls = {};
                      for (let i = 0; i < val.listSemuaKunjungan.length; i++) {
                        const kunjungan = val.listSemuaKunjungan[i];
                        if (kunjungan.buktiKunjungan) {
                          try {
                            const res = await showUrlDokumenKunjungan(
                              dispatch,
                              {
                                urlImage: kunjungan.buktiKunjungan,
                              },
                            );
                            if (res && res.data && res.data.url) {
                              tempUrls[`kunjungan_${i}`] = res.data.url;
                            }
                          } catch (err) {
                            console.error(
                              "Gagal load image index ke-" + i,
                              err,
                            );
                          }
                        }
                      }
                      setBuktiKunjungan(tempUrls);
                    } else {
                      setBuktiKunjungan({});
                    }
                  }}
                >
                  <i className="fas fa-eye" style={{ fontSize: "14px" }}></i>
                </Button>
              </OverlayTrigger>
            </div>
            <div className="d-flex justify-content-center align-items-center ml-2">
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip id={`tooltip-details-${val._id}`}>
                    Lihat Dokumen
                  </Tooltip>
                }
              >
                <Button
                  className="btn-icon d-flex align-items-center justify-content-center shadow-sm"
                  style={{
                    width: "35px",
                    height: "35px",
                    borderRadius: "10px",
                    backgroundColor: "#FFF7ED",
                    border: "1px solid #FFEDD5",
                    color: "#EA580C",
                    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.backgroundColor = "#EA580C";
                    e.currentTarget.style.color = "#ffffff";
                    e.currentTarget.style.transform = "translateY(-3px)";
                    e.currentTarget.style.boxShadow = "0 6px 12px -2px rgba(234, 88, 12, 0.25)";
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.backgroundColor = "#FFF7ED";
                    e.currentTarget.style.color = "#EA580C";
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow = "0 1px 2px 0 rgba(0, 0, 0, 0.05)";
                  }}
                  onClick={async () => {
                    setModalDokumen(true);
                    setLoadingDokumen(true);
                    setListDokumenAgunan([]);

                    if (val.stepEnam) {
                      let tmp = [];
                      for (const [key, value] of Object.entries(val.stepEnam)) {
                        if (
                          !["_id", "id_pinjaman", "createdAt", "updatedAt", "__v"].includes(key) &&
                          value
                        ) {
                          try {
                            const res = await showUrlDokumen(dispatch, {
                              urlImage: value,
                            });
                            if (res && res.data && res.data.url) {
                              tmp.push({
                                key: key,
                                urlAsli: value,
                                secureUrl: res.data.url,
                              });
                            }
                          } catch (err) {
                            console.error("Gagal load dokumen " + key, err);
                          }
                        }
                      }
                      setListDokumenAgunan(tmp);
                    }
                    setLoadingDokumen(false);
                  }}
                >
                  <i className="fas fa-folder-open" style={{ fontSize: "15px" }}></i>
                </Button>
              </OverlayTrigger>
            </div>
          </>
          ),
        };
      });
      setListPencairan(tmp);
    }
  }, [dataPencairan.listPencairan]);

  const AnyReactComponent = () => (
    <div style={{ position: "relative", transform: "translate(-50%, -100%)" }}>
      <i
        className="fas fa-map-marker-alt text-danger"
        style={{
          fontSize: "30px",
          filter: "drop-shadow(0px 2px 4px rgba(0,0,0,0.3))",
        }}
      ></i>
    </div>
  );

  React.useEffect(() => {
    let tmp = [
      // {
      //   value: "",
      //   isDisabled: false,
      // },
      {
        value: "1",
        label: "Konsumtif",
      },
      {
        value: "2",
        label: "Produktif",
      },
    ];
    setListTujuanPenggunaan(tmp);
  }, [dataPencairan.listPencairan, page, totalPerHalaman]);

  const customStyles = {
    table: {
      style: {
        backgroundColor: "#ffffff",
      },
    },
    header: {
      style: {
        minHeight: "56px",
      },
    },
    headRow: {
      style: {
        backgroundColor: "#F1F5F9", // Warna abu muda kebiruan yang lebih segar
        borderTopStyle: "solid",
        borderTopWidth: "1px",
        borderTopColor: "#E2E8F0",
        minHeight: "50px",
      },
    },
    headCells: {
      style: {
        color: "#475569",
        fontWeight: "800",
        fontSize: "12px",
        textTransform: "uppercase",
        letterSpacing: "0.5px",
      },
    },
    rows: {
      style: {
        minHeight: "60px", // Row sedikit lebih tinggi agar lega
        "&:not(:last-child)": {
          borderBottomStyle: "solid",
          borderBottomWidth: "1px",
          borderBottomColor: "#F1F5F9",
        },
        "&:hover": {
          backgroundColor: "#F8FAFC",
          transition: "0.3s",
          cursor: "pointer",
        },
      },
    },
    cells: {
      style: {
        fontSize: "13px",
        color: "#1E293B",
        fontWeight: "500",
        paddingLeft: "16px",
        paddingRight: "16px",
      },
    },
  };

  const colPencairan = [
    {
      name: "NO",
      width: "100px",
      center: true,
      style: {
        borderRight: "1px solid #E2E8F0",
        fontWeight: "800",
        color: "#475569",
        fontFamily: "system-ui, -apple-system, sans-serif",
      },
      selector: (row, index) =>
        index + dataPencairan.listPencairan.pagingCounter,
    },
    {
      name: "REFERENSI ID",
      minWidth: "300px",
      center: true,
      cell: (row) => (
        <div
          className="d-flex align-items-center justify-content-center"
          style={{ fontFamily: "system-ui, -apple-system, sans-serif" }}
        >
          <b
            className="text-dark mr-2"
            style={{
              fontSize: "13px",
              fontWeight: "800",
              letterSpacing: "-0.3px",
            }}
          >
            {row.id_pinjaman}
          </b>
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id={`copy-${row.id_pinjaman}`}>Salin ID</Tooltip>}
          >
            <i
              className="far fa-copy text-muted"
              style={{
                cursor: "pointer",
                fontSize: "13px",
                transition: "color 0.15s ease",
              }}
              onMouseOver={(e) =>
                (e.currentTarget.className = "far fa-copy text-primary")
              }
              onMouseOut={(e) =>
                (e.currentTarget.className = "far fa-copy text-muted")
              }
              onClick={() => {
                navigator.clipboard.writeText(row.id_pinjaman);
                Swal.fire({
                  title: "Tersalin!",
                  text: `ID ${row.id_pinjaman} berhasil disalin`,
                  icon: "success",
                  timer: 1000,
                  showConfirmButton: false,
                  position: "center",
                  width: "350px",
                });
              }}
            ></i>
          </OverlayTrigger>
        </div>
      ),
    },
    {
      name: "NASABAH",
      minWidth: "290px",
      sortable: true,
      cell: (row) => (
        <div
          style={{
            fontFamily: "system-ui, -apple-system, sans-serif",
            py: "6px",
          }}
        >
          <div
            className="text-dark"
            style={{ fontWeight: "700", fontSize: "13.5px", lineHeight: "1.2" }}
          >
            {row.namaLengkap}
          </div>
          <small
            className="text-muted d-block mt-1"
            style={{ fontWeight: "600", fontSize: "11px" }}
          >
            {row.nomorIdentitas}
          </small>
        </div>
      ),
    },
    {
      name: "TUJUAN",
      minWidth: "140px",
      center: true,
      cell: (row) => {
        const isKonsumtif = row.stepEmpat?.tujuanPenggunaan === "1";
        return (
          <span
            className="badge px-3 py-2"
            style={{
              borderRadius: "8px",
              fontSize: "10.5px",
              fontWeight: "800",
              letterSpacing: "0.3px",
              backgroundColor: isKonsumtif
                ? "rgba(13, 202, 240, 0.12)"
                : "rgba(40, 167, 69, 0.12)",
              color: isKonsumtif ? "#0DCAF0" : "#28A745",
              border: isKonsumtif
                ? "1px solid rgba(13, 202, 240, 0.25)"
                : "1px solid rgba(40, 167, 69, 0.25)",
            }}
          >
            {isKonsumtif ? "KONSUMTIF" : "PRODUKTIF"}
          </span>
        );
      },
    },
    {
      name: "NOMINAL PERMOHONAN",
      minWidth: "190px",
      center: true,
      selector: (row) => row.stepEmpat?.nominalPermohonan,
      cell: (row) => (
        <span
          style={{
            fontWeight: "700",
            color: "#334155",
            fontSize: "13.5px",
            fontFamily: "system-ui, -apple-system, sans-serif",
          }}
        >
          {new Intl.NumberFormat("id-ID", {
            style: "currency",
            currency: "IDR",
            minimumFractionDigits: 0,
          }).format(row.stepEmpat?.nominalPermohonan || 0)}
        </span>
      ),
    },
    {
      name: "NOMINAL PENCAIRAN",
      minWidth: "190px",
      center: true,
      selector: (row) => row.nominalPencairan,
      cell: (row) => (
        <span
          style={{
            fontWeight: "800",
            color: "#28A745",
            fontSize: "13.5px",
            fontFamily: "system-ui, -apple-system, sans-serif",
          }}
        >
          {new Intl.NumberFormat("id-ID", {
            style: "currency",
            currency: "IDR",
            minimumFractionDigits: 0,
          }).format(row.nominalPencairan || 0)}
        </span>
      ),
    },
    {
      name: "NO. AKAD",
      minWidth: "270px",
      cell: (row) => (
        <div
          className="py-2"
          style={{ fontFamily: "system-ui, -apple-system, sans-serif" }}
        >
          <span
            className="text-dark"
            style={{ fontSize: "13px", fontWeight: "700" }}
          >
            {row.noAkad || "-"}
          </span>
        </div>
      ),
    },
    {
      name: "TGL AKAD",
      minWidth: "160px",
      cell: (row) => (
        <div
          className="py-2"
          style={{
            fontFamily: "system-ui, -apple-system, sans-serif",
            fontSize: "13px",
          }}
        >
          <span className="text-dark" style={{ fontWeight: "600" }}>
            <i className="far fa-calendar-check mr-2 text-primary opacity-75"></i>
            {row.tglAkad ? moment(row.tglAkad).format("DD MMM YYYY") : "-"}
          </span>
        </div>
      ),
    },
    {
      name: "CABANG PENCAIRAN",
      minWidth: "240px",
      cell: (row) => (
        <div
          className="w-100 d-flex justify-content-start align-items-center"
          style={{ fontFamily: "system-ui, -apple-system, sans-serif" }}
        >
          <div
            className="px-2-5 py-1 rounded-pill bg-light border text-dark d-flex align-items-center"
            style={{
              fontSize: "12px",
              fontWeight: "700",
              minWidth: "fit-content",
              borderColor: "#E2E8F0 !important",
            }}
          >
            <i className="fas fa-university mr-2 text-primary opacity-75"></i>
            {row.namaCabangPencairan}
          </div>
        </div>
      ),
    },
    {
      name: "TGL KUNJUNGAN TERAKHIR",
      minWidth: "250px",
      cell: (row) => (
        <div
          className="py-2"
          style={{
            fontFamily: "system-ui, -apple-system, sans-serif",
            fontSize: "13px",
          }}
        >
          <span className="text-dark" style={{ fontWeight: "600" }}>
            <i className="far fa-clock mr-2 text-warning opacity-75"></i>
            {row.tglKunjunganTerakhir
              ? moment(row.tglKunjunganTerakhir).format("DD MMM YYYY HH:MM:SS")
              : "-"}
          </span>
        </div>
      ),
    },
    {
      name: "TOTAL KUNJUNGAN",
      minWidth: "180px",
      sortable: true,
      cell: (row) => (
        <div
          style={{
            fontFamily: "system-ui, -apple-system, sans-serif",
            py: "4px",
          }}
        >
          <div
            className="text-dark"
            style={{ fontWeight: "700", fontSize: "12.5px" }}
          >
            <i className="fas fa-street-view mr-1.5 text-secondary small"></i>{" "}
            {row.totalKunjungan || 0} Kunjungan
          </div>
          <small
            className="text-muted d-block mt-0.5"
            style={{ fontWeight: "600", fontSize: "11px" }}
          >
            <i className="fas fa-users mr-1 text-muted small"></i>{" "}
            {row.totalGroupKunjungan || 0} Group
          </small>
        </div>
      ),
    },
    {
      name: "AKSI",
      width: "90px",
      center: true,
      cell: (row) => (
        <div className="d-flex justify-content-center action-button-wrap">
          {row.action}
        </div>
      ),
    },
  ];

  React.useEffect(() => {
    setPending(true);
    getAllPencairan(dispatch, {
      status: "Disetujui",
      // status:
      //   filterStatus === null || filterStatus.value === ""
      //     ? ""
      //     : filterStatus.value,
      cari: "",
      page: page + 1,
      limit: totalPerHalaman,
      tujuanPenggunaan:
        filterTujuanPenggunaan === null || filterTujuanPenggunaan.value === ""
          ? ""
          : filterTujuanPenggunaan.value,
    })
      .then(() => {
        setPending(false);
      })
      .catch((error) => {
        setPending(false);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Terjadi kesalahan saat memuat data.",
        });
      });
  }, [page, totalPerHalaman]);

  return (
    <>
      <Modal
        size="xl" // Ukuran XL agar layout split kiri (data & foto) dan kanan (maps) lega
        show={modalDetails}
        onHide={() => {
          setModalDetails(false);
          setBuktiKunjungan({}); // RESET: Mencegah foto nasabah sebelumnya nyangkut
          setLatitude(null);
          setLongitude(null);
        }}
        centered
        className="modal-modern"
      >
        <Modal.Header closeButton className="border-0 pb-0">
          <Modal.Title className="w-100 text-center mt-3">
            <h4
              className="fw-800 text-dark uppercase mb-0"
              style={{ letterSpacing: "1px" }}
            >
              DETAIL REALISASI PENCAIRAN
            </h4>
            <div
              className="mx-auto mt-2"
              style={{
                width: "50px",
                height: "4px",
                backgroundColor: "#3b82f6",
                borderRadius: "10px",
              }}
            ></div>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="px-4 pb-5">
          <Card className="border-0">
            <Card.Body className="p-0">
              <div className="row mt-4">
                {/* ==================== PANEL LOKASI KIRI: TEXT & DETAIL FOTO (58% / col-lg-7) ==================== */}
                <div className="col-lg-7 row">
                  {/* SEKSI 1: DATA NASABAH */}
                  <div className="col-12 mb-3">
                    <div
                      className="bg-light p-2 px-3 rounded-lg fw-bold text-primary small"
                      style={{ fontSize: "11px" }}
                    >
                      INFORMASI NASABAH & IDENTITAS
                    </div>
                  </div>

                  <DetailRow
                    label="Nama Nasabah"
                    value={detailPencairan.namaLengkap}
                    isPrimary
                    col={12}
                  />
                  <DetailRow
                    label="Nomor KTP (NIK)"
                    value={detailPencairan.nomorIdentitas}
                    col={12}
                  />
                  <DetailRow
                    label="Reference ID"
                    value={detailPencairan.id_pinjaman}
                    color="#0369A1"
                    col={12}
                  />
                  <DetailRow
                    label="Cabang Realisasi"
                    value={detailPencairan.lokasiPencairan?.namaCabang}
                    col={12}
                  />

                  {/* SEKSI 2: DATA KEUANGAN */}
                  <div className="col-12 mb-3 mt-4">
                    <div
                      className="bg-light p-2 px-3 rounded-lg fw-bold text-primary small"
                      style={{ fontSize: "11px" }}
                    >
                      DETAIL NOMINAL & AKAD
                    </div>
                  </div>

                  <DetailRow
                    label="Nominal Permohonan"
                    value={
                      detailPencairan.stepEmpat
                        ? `Rp ${detailPencairan.stepEmpat.nominalPermohonan.toLocaleString("id-ID")}`
                        : "-"
                    }
                    col={12}
                  />
                  <DetailRow
                    label="Nominal Pencairan"
                    value={
                      detailPencairan.nominalPencairan
                        ? `Rp ${detailPencairan.nominalPencairan.toLocaleString("id-ID")}`
                        : "-"
                    }
                    color="#116D6E"
                    col={12}
                  />

                  <div className="col-md-6 border-right">
                    <DetailRow
                      label="No. Akad"
                      value={detailPencairan.noAkad}
                      col={12}
                    />
                    <DetailRow
                      label="Tanggal Akad"
                      value={tanggalAkad}
                      col={12}
                    />
                  </div>
                  <div className="col-md-6">
                    <DetailRow
                      label="No. Agenda"
                      value={detailPencairan.noAgenda}
                      col={12}
                    />
                    <DetailRow
                      label="Tanggal Agenda"
                      value={tanggalAgenda}
                      col={12}
                    />
                  </div>

                  {/* ===== SEKSI BARU 3: RIWAYAT KUNJUNGAN LAPANGAN ===== */}
                  <div className="col-12 mb-3 mt-4">
                    <div
                      className="bg-light p-2 px-3 rounded-lg fw-bold text-primary small"
                      style={{ fontSize: "11px" }}
                    >
                      RIWAYAT KUNJUNGAN LAPANGAN (
                      {detailPencairan.totalKunjungan || 0})
                    </div>
                  </div>

                  <div className="col-12">
                    {!detailPencairan.listSemuaKunjungan ||
                      detailPencairan.listSemuaKunjungan.length === 0 ? (
                      <div
                        className="text-center py-4 text-muted border rounded bg-light"
                        style={{ borderStyle: "dashed" }}
                      >
                        <i
                          className="fas fa-route mb-2"
                          style={{ fontSize: "24px", color: "#cbd5e1" }}
                        ></i>
                        <p className="small mb-0">
                          Belum ada riwayat data kunjungan untuk pengajuan ini.
                        </p>
                      </div>
                    ) : (
                      detailPencairan.listSemuaKunjungan.map(
                        (kunjungan, idx) => {
                          const tglKunjung = kunjungan.tglKunjungan
                            ? new Date(
                              kunjungan.tglKunjungan,
                            ).toLocaleDateString("id-ID", {
                              day: "numeric",
                              month: "long",
                              year: "numeric",
                              hour: "2-digit",
                              minute: "2-digit",
                              second: "2-digit",
                            })
                            : "-";

                          const badgeKeputusanColor =
                            kunjungan.keputusan === "Disetujui"
                              ? "#dcfce7"
                              : kunjungan.keputusan === "Ditolak"
                                ? "#fee2e2"
                                : "#fef9c3";
                          const textKeputusanColor =
                            kunjungan.keputusan === "Disetujui"
                              ? "#16a34a"
                              : kunjungan.keputusan === "Ditolak"
                                ? "#dc2626"
                                : "#ca8a04";

                          const securePhotoUrl =
                            buktiKunjungan[`kunjungan_${idx}`];
                          const isCurrentTargetMap =
                            latitude === parseFloat(kunjungan.lat) &&
                            longitude === parseFloat(kunjungan.long);

                          return (
                            <Card
                              key={idx}
                              className="mb-3 shadow-sm border transition-all"
                              style={{
                                borderRadius: "12px",
                                overflow: "hidden",
                                cursor: "pointer",
                                borderLeft: isCurrentTargetMap
                                  ? "5px solid #3b82f6"
                                  : "1px solid #e2e8f0",
                              }}
                              onClick={() => {
                                if (kunjungan.lat && kunjungan.long) {
                                  setLatitude(parseFloat(kunjungan.lat));
                                  setLongitude(parseFloat(kunjungan.long));
                                }
                              }}
                            >
                              <div className="card-header bg-white border-bottom-0 d-flex justify-content-between align-items-center py-2 px-3">
                                <span className="fw-bold text-secondary small">
                                  <i className="fas fa-map-marker-alt text-danger me-2"></i>
                                  Kunjungan #{idx + 1} (
                                  {kunjungan.idGroupKunjungan || "-"})
                                </span>
                                <span
                                  className="badge px-3 py-1 rounded-pill fw-bold text-uppercase"
                                  style={{
                                    backgroundColor: badgeKeputusanColor,
                                    color: textKeputusanColor,
                                    fontSize: "11px",
                                  }}
                                >
                                  {kunjungan.keputusan || "Proses"}
                                </span>
                              </div>

                              <div className="card-body bg-white pt-1 pb-3 px-3">
                                <div className="row g-3">
                                  <div className="col-md-6 border-right">
                                    <small
                                      className="text-muted d-block mb-0"
                                      style={{ fontSize: "11px" }}
                                    >
                                      Tanggal Kunjungan
                                    </small>
                                    <span className="fw-bold text-dark small d-block mb-2">
                                      {tglKunjung}
                                    </span>

                                    <small
                                      className="text-muted d-block mb-0"
                                      style={{ fontSize: "11px" }}
                                    >
                                      Hasil & Keterangan
                                    </small>
                                    <span className="fw-bold text-dark small d-block mb-2">
                                      {kunjungan.hasil || "-"}{" "}
                                      {kunjungan.keterangan
                                        ? `(${kunjungan.keterangan})`
                                        : ""}
                                    </span>

                                    <small
                                      className="text-muted d-block mb-0"
                                      style={{ fontSize: "11px" }}
                                    >
                                      Plafond & Nett Kunjungan
                                    </small>
                                    <span className="fw-bold text-dark small d-block mb-2">
                                      Rp{" "}
                                      {(kunjungan.plafond || 0).toLocaleString(
                                        "id-ID",
                                      )}{" "}
                                      / Rp{" "}
                                      {(kunjungan.nett || 0).toLocaleString(
                                        "id-ID",
                                      )}
                                    </span>

                                    <small
                                      className="text-muted d-block mb-0"
                                      style={{ fontSize: "11px" }}
                                    >
                                      Koordinat Lokasi
                                    </small>
                                    <span
                                      className="text-primary fw-bold small d-block mb-0"
                                      style={{ fontSize: "11px" }}
                                    >
                                      <i className="fas fa-location-arrow me-1"></i>{" "}
                                      Lihat di Peta →
                                    </span>
                                  </div>

                                  <div className="col-md-6 d-flex flex-column align-items-end justify-content-center pt-2 pt-md-0">
                                    <small
                                      className="text-muted d-block mb-2 fw-bold align-self-end pe-md-2"
                                      style={{
                                        fontSize: "11px",
                                        letterSpacing: "0.5px",
                                      }}
                                    >
                                      BUKTI KUNJUNGAN LAPANGAN
                                    </small>

                                    {kunjungan.buktiKunjungan ? (
                                      securePhotoUrl ? (
                                        <a
                                          href={securePhotoUrl}
                                          target="_blank"
                                          rel="noreferrer"
                                          className="position-relative d-block w-100 pe-md-2"
                                          style={{ maxWidth: "340px" }}
                                          onClick={(e) => e.stopPropagation()}
                                        >
                                          <div
                                            className="position-relative overflow-hidden rounded-lg border shadow-sm"
                                            style={{ borderRadius: "10px" }}
                                          >
                                            <img
                                              src={securePhotoUrl}
                                              alt="Bukti Kunjungan"
                                              className="img-fluid object-fit-cover w-100"
                                              style={{
                                                height: "200px",
                                                cursor: "pointer",
                                              }}
                                            />
                                            <div
                                              className="position-absolute bg-dark text-white d-flex align-items-center justify-content-center border"
                                              style={{
                                                opacity: 0.85,
                                                fontSize: "11px",
                                                bottom: "8px",
                                                right: "8px",
                                                width: "28px",
                                                height: "28px",
                                                borderRadius: "6px",
                                                borderColor:
                                                  "rgba(255,255,255,0.2)",
                                              }}
                                            >
                                              <i className="fas fa-search-plus"></i>
                                            </div>
                                          </div>
                                        </a>
                                      ) : (
                                        <div
                                          className="text-muted small py-4 border rounded text-center bg-light w-100 pe-md-2"
                                          style={{
                                            borderStyle: "dashed",
                                            height: "200px",
                                            maxWidth: "340px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                          }}
                                        >
                                          <div>
                                            <i className="fas fa-spinner fa-spin me-2 text-primary"></i>
                                            <span>Memuat Gambar...</span>
                                          </div>
                                        </div>
                                      )
                                    ) : (
                                      <div
                                        className="text-muted small py-4 border rounded text-center bg-light w-100 pe-md-2"
                                        style={{
                                          borderStyle: "dashed",
                                          height: "200px",
                                          maxWidth: "340px",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                        }}
                                      >
                                        <div>
                                          <i
                                            className="far fa-image mb-2 d-block"
                                            style={{
                                              fontSize: "24px",
                                              color: "#cbd5e1",
                                            }}
                                          ></i>
                                          <span>Tidak ada foto</span>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </Card>
                          );
                        },
                      )
                    )}
                  </div>
                </div>

                {/* ==================== PANEL MAPS KANAN: STICKY GOOGLE MAPS PREVIEW (42% / col-lg-5) ==================== */}
                <div
                  className="col-lg-5 mt-4 mt-lg-0"
                  style={{
                    position: "sticky",
                    top: "10px",
                    height: "fit-content",
                  }}
                >
                  <div
                    className="bg-light p-2 px-3 rounded-lg fw-bold text-primary small mb-3"
                    style={{ fontSize: "11px" }}
                  >
                    PREVIEW LOKASI MAPS KUNJUNGAN
                  </div>
                  <div
                    className="border rounded-xl overflow-hidden shadow-sm position-relative"
                    style={{ height: "480px", borderRadius: "16px" }}
                  >
                    {latitude && longitude ? (
                      <GoogleMapReact
                        bootstrapURLKeys={{
                          key: "AIzaSyDEQbFkmNjBsVFEHW_pLszpxLNOXr5HLYk",
                        }}
                        center={{ lat: latitude, lng: longitude }}
                        zoom={15}
                      >
                        <AnyReactComponent lat={latitude} lng={longitude} />
                      </GoogleMapReact>
                    ) : (
                      <div className="w-100 h-100 d-flex flex-column align-items-center justify-content-center bg-white text-muted p-4 text-center">
                        <i
                          className="fas fa-map-marked-alt mb-3"
                          style={{ fontSize: "40px", color: "#cbd5e1" }}
                        ></i>
                        <p className="small mb-0 fw-bold">
                          Titik Koordinat Tidak Tersedia
                        </p>
                        <p className="small text-muted">
                          Nasabah belum melangsungkan tahapan kunjungan
                          lapangan.
                        </p>
                      </div>
                    )}
                  </div>
                  {latitude && longitude && (
                    <div className="mt-2 text-center">
                      <a
                        href={`https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`}
                        target="_blank"
                        rel="noreferrer"
                        className="btn btn-sm btn-outline-secondary px-3"
                        style={{
                          borderRadius: "8px",
                          fontSize: "11px",
                          fontWeight: "600",
                        }}
                      >
                        <i className="fas fa-external-link-alt me-2"></i>Buka di
                        Google Maps asli
                      </a>
                    </div>
                  )}
                </div>
              </div>
            </Card.Body>
          </Card>
        </Modal.Body>

        <Modal.Footer className="border-0 justify-content-center pb-4">
          <Button
            variant="secondary"
            onClick={() => {
              setModalDetails(false);
              setBuktiKunjungan({}); // RESET: Mencegah foto nasabah sebelumnya nyangkut saat ditekan tombol tutup biasa
              setLatitude(null);
              setLongitude(null);
            }}
            style={{
              borderRadius: "10px",
              padding: "10px 40px",
              fontWeight: "bold",
            }}
          >
            Tutup
          </Button>
        </Modal.Footer>
      </Modal>

      {/* ================= MODAL DOKUMEN NASABAH ================= */}
      <Modal
        size="xl"
        show={modalDokumen}
        onHide={() => setModalDokumen(false)}
        centered
        className="modal-modern"
      >
        <Modal.Header closeButton className="border-0 pb-0">
          <Modal.Title className="w-100 text-center mt-3">
            <h4
              className="fw-800 text-dark uppercase mb-0"
              style={{ letterSpacing: "1px" }}
            >
              DOKUMEN NASABAH
            </h4>
            <div
              className="mx-auto mt-2"
              style={{
                width: "50px",
                height: "4px",
                backgroundColor: "#E63946",
                borderRadius: "10px",
              }}
            ></div>
            <p className="text-muted small mt-2 mb-0">
              Pratinjau seluruh dokumen kelengkapan nasabah
            </p>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="px-4 pb-5 mt-4">
          {loadingDokumen ? (
            <div className="text-center py-5">
              <l-quantum size="55" speed="2.75" color="#E63946"></l-quantum>
              <h5 className="mt-3 fw-600 text-muted">Memuat Dokumen...</h5>
            </div>
          ) : listDokumenAgunan.length > 0 ? (
            <Row>
              {listDokumenAgunan.map((doc, idx) => {
                const isPdf =
                  doc.secureUrl.toLowerCase().includes(".pdf") ||
                  doc.urlAsli.toLowerCase().includes(".pdf");
                return (
                  <Col md={6} lg={4} key={idx} className="mb-4">
                    <Card
                      className="h-100 shadow-sm border-0 doc-card"
                      style={{
                        borderRadius: "15px",
                        overflow: "hidden",
                        transition: "all 0.3s ease",
                      }}
                    >
                      <div
                        className="bg-light d-flex align-items-center justify-content-center p-3 position-relative group"
                        style={{ height: "260px" }}
                      >
                        {isPdf ? (
                          <div className="w-100 h-100 position-relative rounded shadow-sm border overflow-hidden bg-white">
                            <iframe
                              src={`${doc.secureUrl}#toolbar=0&navpanes=0&scrollbar=0`}
                              title={doc.key}
                              className="w-100 h-100"
                              style={{ border: "none", overflow: "hidden" }}
                              scrolling="no"
                            />
                            <div
                              className="position-absolute"
                              style={{
                                bottom: "10px",
                                right: "10px",
                                zIndex: 10,
                              }}
                            >
                              <OverlayTrigger
                                placement="top"
                                overlay={<Tooltip id={`tooltip-pdf-${idx}`}>Buka ukuran penuh</Tooltip>}
                              >
                                <Button
                                  variant="danger"
                                  className="shadow-sm border-0 d-flex align-items-center justify-content-center"
                                  style={{ borderRadius: "8px", width: "35px", height: "35px", padding: 0, opacity: 0.9 }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleBukaUkuranPenuh(doc.urlAsli, doc.secureUrl);
                                  }}
                                >
                                  <i className="fas fa-expand"></i>
                                </Button>
                              </OverlayTrigger>
                            </div>
                          </div>
                        ) : (
                          <div className="w-100 h-100 position-relative rounded shadow-sm border overflow-hidden">
                            <img
                              src={doc.secureUrl}
                              alt={doc.key}
                              className="img-fluid w-100 h-100 object-fit-cover"
                              style={{ objectFit: "cover", cursor: "zoom-in" }}
                              onClick={() => handleBukaUkuranPenuh(doc.urlAsli, doc.secureUrl)}
                            />
                            <div
                              className="position-absolute bg-dark text-white d-flex align-items-center justify-content-center"
                              style={{
                                opacity: 0.75,
                                fontSize: "14px",
                                bottom: "10px",
                                right: "10px",
                                width: "35px",
                                height: "35px",
                                borderRadius: "8px",
                                cursor: "pointer",
                                pointerEvents: "none"
                              }}
                            >
                              <i className="fas fa-search-plus"></i>
                            </div>
                          </div>
                        )}
                      </div>
                      <Card.Body className="bg-white border-top text-center py-3">
                        <h6
                          className="mb-0 fw-bold text-dark text-uppercase"
                          style={{ fontSize: "13px", letterSpacing: "0.5px" }}
                        >
                          {doc.key.replace(/([A-Z])/g, " $1").trim()}
                        </h6>
                        <small
                          className="text-muted d-block text-truncate mt-1 px-2"
                          style={{ fontSize: "11px" }}
                        >
                          {doc.urlAsli.split("/").pop()}
                        </small>
                      </Card.Body>
                    </Card>
                  </Col>
                );
              })}
            </Row>
          ) : (
            <div className="text-center py-5 text-muted">
              <i
                className="far fa-folder-open mb-3"
                style={{ fontSize: "60px", color: "#cbd5e1" }}
              ></i>
              <h5 className="fw-bold">Tidak ada dokumen</h5>
              <p className="small">
                Nasabah ini belum memiliki dokumen yang dilampirkan pada sistem.
              </p>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer className="border-0 justify-content-center pb-4">
          <Button
            variant="secondary"
            onClick={() => setModalDokumen(false)}
            style={{
              borderRadius: "10px",
              padding: "10px 40px",
              fontWeight: "bold",
            }}
          >
            Tutup
          </Button>
        </Modal.Footer>
      </Modal>



      <Container fluid className="py-4">
        <Row>
          <Col md="12">
            <Card
              className="border-0 shadow-sm"
              style={{ borderRadius: "20px" }}
            >
              <Card.Header className="bg-white border-0 pt-4 px-4">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <div>
                    <h3
                      className="fw-800 text-dark m-0"
                      style={{ letterSpacing: "1px" }}
                    >
                      LIST PENCAIRAN
                    </h3>
                    <p className="text-muted small mb-0">
                      Daftar pengajuan nasabah yang telah disetujui dan cair.
                    </p>
                  </div>
                  {/* Badge Indicator */}
                  {/* <div className="bg-light px-3 py-2 rounded-pill border">
                    <span className="text-primary fw-bold small">
                      {listPencairan.length} Total Data
                    </span>
                  </div> */}
                </div>

                {/* FILTER TOOLBAR */}
                <div className="bg-light p-3 rounded-xl border-0 shadow-inner mt-3">
                  <Row className="align-items-center g-2">
                    <Col md={4} sm={12}>
                      <InputGroup className="bg-white rounded-lg border">
                        <InputGroup.Prepend>
                          <InputGroup.Text className="bg-transparent border-0 text-muted">
                            <i className="fas fa-search"></i>
                          </InputGroup.Text>
                        </InputGroup.Prepend>
                        <Form.Control
                          className="border-0 bg-transparent"
                          type="text"
                          value={searchText}
                          onChange={handleSearch}
                          onKeyDown={handleKeyDown}
                          placeholder="Cari ID Ref / Nama Nasabah..."
                        />
                        {searchText && (
                          <InputGroup.Append>
                            <InputGroup.Text
                              className="bg-transparent border-0 text-muted cursor-pointer"
                              onClick={handleClearSearch}
                            >
                              <i className="fas fa-times"></i>
                            </InputGroup.Text>
                          </InputGroup.Append>
                        )}
                      </InputGroup>
                    </Col>

                    <Col md={3} sm={12}>
                      <Select
                        className="react-select primary"
                        classNamePrefix="react-select"
                        value={filterTujuanPenggunaan}
                        onChange={(selectedOption) => {
                          setFilterTujuanPenggunaa(selectedOption);
                          setPilihTujuanPenggunaan(selectedOption.value);
                        }}
                        options={[
                          { value: "", label: "Semua Tujuan" },
                          ...listTujuanPenggunaan,
                        ]}
                        placeholder="Filter Tujuan..."
                      />
                    </Col>

                    <Col md="auto" sm={12}>
                      <Button
                        variant="primary"
                        className="px-4 fw-bold shadow-sm d-flex align-items-center"
                        style={{ borderRadius: "10px", height: "40px" }}
                        onClick={handleFilterChange}
                      >
                        <i className="fas fa-filter mr-2"></i> FILTER
                      </Button>
                    </Col>
                  </Row>
                </div>
              </Card.Header>

              <Card.Body className="px-4">
                {pending ? (
                  <div className="py-5 text-center">
                    <l-quantum
                      size="55"
                      speed="2.75"
                      color="#3b82f6"
                    ></l-quantum>
                    <h5 className="mt-3 fw-600 text-muted">
                      Menyiapkan Data...
                    </h5>
                  </div>
                ) : (
                  <div className="table-responsive-custom">
                    <DataTable
                      columns={colPencairan}
                      data={listPencairan}
                      customStyles={customStyles}
                      pagination={false} // Kita pakai ReactPaginate manual di bawah
                      progressPending={pending}
                      highlightOnHover
                      pointerOnHover
                    />

                    {/* CUSTOM PAGINATION FOOTER */}
                    <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mt-4 pb-3 border-top pt-4">
                      <div className="d-flex align-items-center mb-3 mb-md-0">
                        <span className="text-muted small fw-bold mr-3">
                          Tampilkan
                        </span>
                        <div style={{ width: "100px" }}>
                          <Select
                            classNamePrefix="react-select"
                            value={options.find(
                              (opt) => opt.value === totalPerHalaman,
                            )}
                            onChange={handlePageSizeChange}
                            options={options}
                            menuPlacement="top"
                          />
                        </div>
                        <span className="text-muted small ml-3">
                          baris per halaman
                        </span>
                      </div>

                      <ReactPaginate
                        forcePage={page}
                        containerClassName="pagination justify-content-end mb-0" // Container utama
                        pageClassName="page-item" // Item box angka
                        pageLinkClassName="page-link" // Link tombol angka
                        previousClassName="page-item" // Item box Previous
                        previousLinkClassName="page-link" // Link tombol Previous
                        nextClassName="page-item" // Item box Next
                        nextLinkClassName="page-link" // Link tombol Next
                        breakClassName="page-item" // Item box titik-titik (...)
                        breakLinkClassName="page-link" // Link tombol titik-titik
                        activeClassName="active" // State aktif
                        disabledClassName="disabled" // State disabled
                        pageCount={dataPencairan.listPencairan.totalPages || 1}
                        pageRangeDisplayed={3}
                        marginPagesDisplayed={1}
                        nextLabel={<i className="fas fa-chevron-right"></i>}
                        previousLabel={<i className="fas fa-chevron-left"></i>}
                        onPageChange={(val) => setPage(val.selected)}
                      />
                    </div>
                  </div>
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <style>{`
    .fw-800 { font-weight: 800; }
    .fw-600 { font-weight: 600; }
    .rounded-xl { border-radius: 15px !important; }
    .rounded-lg { border-radius: 10px !important; }
    .shadow-inner { box-shadow: inset 0 2px 4px 0 rgba(0,0,0,0.05); }
    .cursor-pointer { cursor: pointer; }
    
    /* Style untuk tabel agar lebih lega */
    .rdt_Table { border-radius: 10px; overflow: hidden; }
    .rdt_TableHeadRow { background-color: #f8fafc !important; color: #1e293b; font-weight: 700; text-transform: uppercase; font-size: 11px; }
    
    /* Pagination Styling */
    .paginations { display: flex; list-style: none; padding: 0; }
    .pages-items-containers { margin: 0 3px; border-radius: 8px; background: #f1f5f9; transition: all 0.2s; }
    .pages-links-labels { padding: 8px 14px; color: #475569; display: block; text-decoration: none; font-weight: 600; font-size: 13px; }
    .pages-items-containers:hover { background: #e2e8f0; }
    .actives { background: #3b82f6 !important; }
    .activess { color: white !important; }
  `}</style>
      </Container>
    </>
  );
}

export default Pencairan;
